import type {
  ConfirmPrescription,
  ConfirmPrescriptionResult,
  PlannedMedicationView,
  TreatmentStartView,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-1070 (TES-1069 S0 + S1) — the patient's treatment-start state and the
// doctor's prescription step (TES-1150: "Bekräfta receptstatus").

const base = (patientId: string) =>
  `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}/treatment-start`;

export async function fetchTreatmentStart(
  patientId: string,
): Promise<TreatmentStartView> {
  const res = await apiFetch(base(patientId), {
    headers: tenantHeader(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function confirmPrescription(
  patientId: string,
  body: ConfirmPrescription,
): Promise<ConfirmPrescriptionResult> {
  const res = await apiFetch(`${base(patientId)}/confirm-prescription`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...tenantHeader() },
    body: JSON.stringify(body),
    ...withCredentials,
  });
  return jsonOr401(res);
}

// TES-1185 — the planned medication and its history (TES-1180 point 1).
export async function fetchPlannedMedication(
  patientId: string,
): Promise<PlannedMedicationView> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}/planned-medication`,
    { headers: tenantHeader(), ...withCredentials },
  );
  return jsonOr401(res);
}
